import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import { Table } from "../../../../components/atoms";
import { getTableToRender } from "./helpers";
import {
  getCbioPortalVersion,
  getCbioPortalData,
} from "../../../../state/selectors/CBioPortalComponent.selectors";
import ChartsGroup from "../../../../components/atoms/charts/ChartsGroup";
import AgeChart from "../../../../components/atoms/charts/AgeChart";
import Chart from "../../../../components/atoms/charts/Chart";
import withErrorGuard from "../../../../HOC/withErrorGuard";

const CBioPortal = (props) => {
  const { cbioPortalVersion, cbioPortalData } = props;
  if (!cbioPortalData) return null;
  // charts data
  const sexPieData = cbioPortalData.sex;
  const survivalPieData = cbioPortalData.os_status;
  const ageGroupsData = cbioPortalData.age_freq;
  const cancerTypeGroupsData = cbioPortalData.cancer_type;
  const dfsStatusGroupsData = cbioPortalData.tumor_status || [];
  const centerData = cbioPortalData.center;
  const raceData = cbioPortalData.race;
  const radiationData = cbioPortalData.radiation_therapy;
  const {
    oncotree_code: oncotreeCode,
    cancer_name: cancerName,
    tissue_type: tissueType,
  } = cbioPortalData;
  const table = getTableToRender(cbioPortalData);
  const url = "https://www.cbioportal.org/";

  return (
    <div className="varsome-result-fixed">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          version={cbioPortalVersion}
          url={url}
          content={
            <div className="tw-p-5">
              <h5> Summary of results </h5>
              <h6>
                <b>{"Total samples: "}</b>
                {cbioPortalData.total_samples
                  ? cbioPortalData.total_samples
                      .toLocaleString()
                      .replace(",", " ")
                  : ""}
              </h6>
              <div className="tw-overflow-y-auto tw-ml-0 tw-mb-8">
                <Table rows={table} styles={{ overflow: "auto" }} />
              </div>
              <div className="varsome-inner-container">
                <ChartsGroup>
                  <Chart data={sexPieData} title="Sex" showEmptyState={false} />
                  <Chart
                    data={survivalPieData}
                    title="Vital status"
                    showEmptyState={false}
                  />
                  <AgeChart
                    data={ageGroupsData}
                    title="Age frequency"
                    showEmptyState={false}
                  />
                  <Chart
                    data={cancerTypeGroupsData}
                    title="Cancer type"
                    showEmptyState={false}
                  />
                  <Chart
                    data={centerData}
                    title="Center"
                    showEmptyState={false}
                  />
                  <Chart
                    data={dfsStatusGroupsData}
                    title="Tumor status"
                    showEmptyState={false}
                  />
                  <Chart data={raceData} title="Race" showEmptyState={false} />
                  <Chart
                    data={radiationData}
                    title="Radiation"
                    showEmptyState={false}
                  />
                  <Chart
                    showEmptyState={false}
                    data={oncotreeCode}
                    title="Oncotree code"
                  />
                  <Chart
                    showEmptyState={false}
                    data={cancerName}
                    title="Cancer name"
                  />
                  <Chart
                    showEmptyState={false}
                    data={tissueType}
                    title="Tissue type"
                  />
                </ChartsGroup>
              </div>
            </div>
          }
          title="cBioPortal"
        />
      </div>
    </div>
  );
};

CBioPortal.propTypes = {
  cbioPortalVersion: PropTypes.string,
  cbioPortalData: PropTypes.shape({
    sex: PropTypes.arrayOf(PropTypes.shape({})),
    tissue_type: PropTypes.arrayOf(PropTypes.shape({})),
    oncotree_code: PropTypes.arrayOf(PropTypes.shape({})),
    os_status: PropTypes.arrayOf(PropTypes.shape({})),
    age_freq: PropTypes.arrayOf(PropTypes.shape({})),
    cancer_type: PropTypes.arrayOf(PropTypes.shape({})),
    cancer_name: PropTypes.arrayOf(PropTypes.shape({})),
    tumor_status: PropTypes.arrayOf(PropTypes.shape({})),
    center: PropTypes.arrayOf(PropTypes.shape({})),
    race: PropTypes.arrayOf(PropTypes.shape({})),
    radiation_therapy: PropTypes.arrayOf(PropTypes.shape({})),
    total_samples: PropTypes.number,
    hotspot: PropTypes.bool,
    cDNAPosition: PropTypes.string,
    canonical: PropTypes.bool,
    n_alt_count: PropTypes.number,
    n_ref_count: PropTypes.number,
    t_alt_count: PropTypes.number,
    t_ref_count: PropTypes.number,
    ma_fImpact: PropTypes.string,
    ma_protein_change: PropTypes.string,
    ensp: PropTypes.string,
    uniparc: PropTypes.string,
  }),
};

CBioPortal.defaultProps = {
  cbioPortalData: null,
  cbioPortalVersion: null,
};

const mapStateToProps = (state) => {
  return {
    cbioPortalVersion: getCbioPortalVersion(state),
    cbioPortalData: getCbioPortalData(state),
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorGuard(CBioPortal, "CBioPortalComponent", "cBioPortal"));
